import { Dispatch, FC, SetStateAction, useState } from 'react'
import Icon from '../icon'

interface RatingProp {
  count?: number
  size?: number
  color?: string
  rating: number
  disabled?: boolean
  setRating?: Dispatch<SetStateAction<number>>
}

const Rating: FC<RatingProp> = ({
  count = 5,
  size = 40,
  rating,
  setRating,
  disabled,
  color = '#f59e0b',
}) => {
  const [hovered, setHovered] = useState(0)
  const active = hovered || rating

  return (
    <div className="flex items-center gap-1" role="radiogroup">
      {Array.from({ length: count }, (_, i) => i + 1).map((val) => (
        <button
          disabled={disabled}
          key={val}
          role="radio"
          aria-checked={val === rating}
          aria-label={`${val} star${val !== 1 ? 's' : ''}`}
          className="p-0.5 rounded focus-visible:outline-2
                     transition-transform hover:scale-110"
          onMouseEnter={() => setHovered(val)}
          onMouseLeave={() => setHovered(0)}
          onClick={() => {
            if (setRating) {
              setRating(val)
            }
          }}
        >
          <Icon
            id="star-icon"
            width={size}
            height={size}
            color={val <= active ? color : '#d1d5db'}
          />
        </button>
      ))}
    </div>
  )
}

export default Rating
